<div *ngIf="program | async; let program" class="fx-col program-event" [ngStyle]="{'padding-top':'10px'}">
	<!-- <span class="but-see-program" (click)="seeProgramDetail=!seeProgramDetail">Program</span> -->
 	<span  *ngFor="let composition of program;let i=index" class="fx-row fx-wrap program-name">
		<strong>{{ composition.composerlastname }}</strong>, &nbsp; {{ composition.compositiontitle }}
	</span>
</div>